import AnnualLeave from '../components/annualleave'

const AnnualLeaves = () => {
  
  return (
    <>   
    <AnnualLeave/>
    </>
  )
}

export default AnnualLeaves